import type { Route } from 'vue-router'
import type { Store } from 'vuex'
import type { AppRoute, GuardResolveFunction } from '../models'
import { CONTAINER } from '../config/inversify.config'
import { TYPES } from '../config/inversify.types'
import { GuardClass } from '../models'
import { APP_CONSTS } from '../store'
import { TOOLING_CONSTS } from '../store/tooling/tooling.consts'

export class ToolingGuard extends GuardClass {
  static async execute(
    this: void,
    to: AppRoute,
    from: Route,
    next: GuardResolveFunction,
  ): Promise<void> {
    const store = CONTAINER.get<Store<unknown>>(TYPES.Store)

    try {
      const tool = to.meta?.featureId
      store.dispatch(`${APP_CONSTS.moduleName}/${APP_CONSTS.actions.setLoading}`, true)
      await store.dispatch(
        `${TOOLING_CONSTS.moduleName}/${TOOLING_CONSTS.actions.loadToolConfig}`,
        { tool },
      )
    } catch (error) {
    } finally {
      store.dispatch(`${APP_CONSTS.moduleName}/${APP_CONSTS.actions.setLoading}`, false)
      next()
    }
  }
}
